import { render } from "./TheQuizResults.vue?vue&type=template&id=c489405e"
import script from "./TheQuizResults.vue?vue&type=script&lang=js"
export * from "./TheQuizResults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__